import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TESTIMONIALS } from "../../data/site";

export default function Testimonials() {
    return (
        <section data-testid="testimonials-section" className="relative border-t border-slate-200 bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <Eyebrow testId="testimonials-eyebrow">Testimonials</Eyebrow>
                        <h2 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                            What clients say.
                        </h2>
                    </div>
                    <p className="max-w-md text-sm leading-relaxed text-slate-500 sm:text-base">
                        Feedback from the teams we build with.
                        <span className="mt-2 block font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
                            Sample quotes — replace with real client feedback.
                        </span>
                    </p>
                </Reveal>

                <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3 lg:gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={i} delay={i * 0.08}>
                            <figure
                                data-testid={`testimonial-card-${i + 1}`}
                                className="group relative flex h-full flex-col rounded-2xl border border-slate-200 bg-paper p-7 shadow-card transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-hover sm:p-8"
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-subtle text-brand transition-colors duration-500 group-hover:bg-brand group-hover:text-white">
                                        <Quote className="h-4 w-4" strokeWidth={1.8} />
                                    </div>
                                    <span className="rounded-full border border-brand/20 bg-white px-3 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.18em] text-slate-400">
                                        Sample
                                    </span>
                                </div>
                                <blockquote className="mt-6 flex-1 text-sm leading-relaxed text-slate-700 sm:text-base">
                                    "{t.quote}"
                                </blockquote>
                                <figcaption className="mt-7 border-t border-slate-200 pt-5">
                                    <p className="font-display text-base font-semibold tracking-tight text-slate-900">
                                        {t.name}
                                    </p>
                                    <p className="mt-0.5 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
                                        {t.role}
                                    </p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
